import React, { useEffect, useContext } from 'react';
import UserContext from '../../contexts/UserContext';
import DashboardContext from '../../contexts/DashboardContext';
import { Redirect, navigate } from '@reach/router';
import Splasher from '../Splasher';
import useIdle from 'react-use/lib/useIdle';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { loading, currentUser, signOut } = useContext(UserContext);
  const isIdle = useIdle(300e3);
  if (isIdle) {
    if (process.env.NODE_ENV !== 'development') {
      console.log('user is idle');
      signOut(window.location.pathname);
      navigate('/sign-in');
    }
  }

  console.log('INSIDE PRIVATE ROUTE', currentUser, loading);
  console.log('LOADING PRIVATE: ', loading);

  if (loading) {
    return <Splasher />;
  } else {
    return (
      <>{currentUser ? <Component {...rest} /> : <Redirect to="sign-in" noThrow />}</>
    );
  }
};

export default PrivateRoute;
